export const normalizeDomainHost = (value) => {
  const raw = String(value || '').trim();
  if (!raw) return '';
  try {
    const withProtocol = /^[a-z][a-z0-9+\-.]*:\/\//i.test(raw) ? raw : `https://${raw}`;
    const parsed = new URL(withProtocol);
    return parsed.hostname.replace(/^www\./i, '').toLowerCase();
  } catch (error) {
    return raw
      .replace(/^https?:\/\//i, '')
      .replace(/^www\./i, '')
      .split('/')[0]
      .toLowerCase();
  }
};

export const AHREFS_DR_HELP =
  'Domain Rating (DR) from Ahrefs — a 0–100 score of backlink profile strength. Data via the Ahrefs free API (~50 lookups/min).';

export const AHREFS_ATTRIBUTION_URL = 'https://ahrefs.com/';

export const formatAhrefsDr = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  return String(n);
};

export const isAhrefsDrLoading = (competitor, row) => {
  if (competitor?.ahrefs_dr_status !== 'fetching') return false;
  const dr = row?.ahrefs_dr ?? row?.target_ahrefs_dr;
  return dr === null || dr === undefined;
};
